import React, { FC } from 'react'
import Head from 'next/head'
import getConfig from 'next/config'

const cdnBasePath = getConfig().publicRuntimeConfig.cdnBasePath || ''

const MyHead: FC = () => {
  return (
    <Head>
      <title>Shophelp</title>

      <link rel="preconnect" href={`${cdnBasePath}`} />
      <link rel="preconnect" href="https://fonts.gstatic.com" />
      <link rel="preconnect" href="https://cdnjs.cloudflare.com" />
      <link rel="dns-prefetch" href="https://www.paypal.com" />
      <link rel="preconnect" href="https://www.paypal.com" />
      <link rel="dns-prefetch" href={`${cdnBasePath}`} />
      <link rel="shortcut icon" href="/favicon.ico" />
      <link rel="icon" href="/favicon.ico" sizes="any" />
      <meta name="apple-itunes-app" content="app-id=6753154632" />
      <meta key="description" name="description" content={'Shophelp'}></meta>
      <meta property="og:type" content={'website'}></meta>
      <meta property="og:title" content={'Shophelp'}></meta>
      <meta property="og:site_name" content={'Shophelp'}></meta>
      <meta property="og:description" content={'Shophelp'}></meta>
      <meta property="og:url" content={'web.shophelp.com'}></meta>
      <meta key="theme-color" name="theme-color" content="#1B1B1B"></meta>
      <meta
        key="apple-mobile-web-app-capable"
        name="apple-mobile-web-app-capable"
        content="yes"
      ></meta>
      <meta
        key="apple-mobile-web-app-title"
        name="apple-mobile-web-app-title"
        content={'Shophelp'}
      ></meta>
      <meta
        key="viewport"
        name="viewport"
        content="width=device-width, initial-scale=1, user-scalable=no, viewport-fit=cover"
      ></meta>
    </Head>
  )
}

export default MyHead
